import React, { useState } from 'react'
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
import { FaEdit,FaPlus } from "react-icons/fa";
import RouteModal from '../../../Component/BasicComponents/Modal/RouteModal';
import OrgUnitTableModalContent from '../ModalContent/OrgUnitTableModalContent';
import { useGetOrgList } from './hooks/useSettingsMasters';
interface RowDataInterface {
  UnitName?: string;
  Scountry?: string;
  CanDoCustomPlaylist?: string; 
  IsExposed?: string;         
  CurrencyId?: number;
  CountryId?: number;
  PunchinOnHoliday?: number;
  PunchinOnLeave?: number;
  PunchinOnWeekoff?: number;
  OrgunitAdminPosition?:number;
  Orgunitid?:number
  PositionName?:string
  EmployeeId:number[] 
}
const orgUnitDataColumns =(handleEdit:(row:any)=>void )=>[
  {
    name: "Name",
    selector: (row: { UnitName: string }) => row.UnitName,
    sortable: true,
    width: "150px",
  },
  {
    name: "Country",
    selector: (row: { Scountry: string }) => row.Scountry,
    sortable: true,
    width: "130px",
  },
  {
    name: "Custom Playlist",
    selector: (row: { CanDoCustomPlaylist: string }) => row.CanDoCustomPlaylist,
    sortable: true,
    width: "170px",
  },
  {
    name: "Is Exposed",
    selector: (row: { IsExposed: string }) => row.IsExposed,
    sortable: true,
    width: "160px",
  },
  {
    name: "Action",
    width: "100px",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];



const OrgUnitTable = () => {
     const [isModalOpen, setIsModalOpen] = useState(false);
     const[status,setStatus] = useState<string | null>(null);
     const [rowData,setrowData]  = useState<RowDataInterface| null>( null);
     const [filterData,setFilterData] = useState({
      search:'',
      start:1,
      length:10
     })    
  

    const {data:orgListData,isLoading,isSuccess} = useGetOrgList({enable:true,params:{
        ...(filterData.search ===""?{}:{search:filterData.search}),
        start:filterData.start,
        length:filterData.length
    }});
  
    //  console.log('orgListData=======>',orgListData);
    //  const handleSubmit = (e: React.FormEvent) => {
    //   e.preventDefault();
    // };
    
      const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
      };
    
      const handleClose = () => {
        setIsModalOpen(false);
      };


  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

   const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };
  const handleEdit =(row:any)=>{
  //  console.log('row==================>',row.EmployeeId);
   setrowData(row);
   setStatus('Edit');
   setIsModalOpen(true);
  }
    
   const AddorgUnithandler =()=>{
    setIsModalOpen(true);
    setStatus('Add');
   } 
    
    return (
        <div className="container mt-3">
      <BasicDataTable
        Title="Org-Unit"
        onChangePage={(pageNo: number) => {
            handlePagination(pageNo);
          }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
            handleonChangeRowsPerPage(newPerPage, page);
          }}

          data={(!isLoading && isSuccess && orgListData?.formateData) || []}
          columns={orgUnitDataColumns(handleEdit)}
          search={false}
          paginationTotalRows={(orgListData?.rowData?.data.recordsTotal) || 0}
          headerContent={
              <button
              onClick={AddorgUnithandler}
              className="btn btn-info"
              style={{ borderRadius: "20px", padding: "6px 12px", display: "flex", alignItems: "center", gap: "5px" }}
            >
              <FaPlus /><span>Add Org Unit</span>
            </button>
            }
        />
        <RouteModal
        toggle={()=>{
          setIsModalOpen(!isModalOpen)
          setStatus(null)
        }}
        isOpen={isModalOpen}
        title={status === 'Add' ? "Add Org-Unit" : "Update Org-Unit" }
        size="lg"
        content={
          <OrgUnitTableModalContent
            // handleSubmit={handleSubmit}
            status={status}
            handleClose={handleClose}
            rowData={rowData}
          />
        }
      />
      </div>
    )
  }
  
  export default OrgUnitTable